module.exports = __webpack_public_path__ + "static/img/timeImg.bace49c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/timeImg.png
// module id = P3q1
// module chunks = 1